import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, pw);
      nav("/admin");
    } catch (e) {
      toast.error("Invalid credentials");
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen bg-cream grid place-items-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl p-8 shadow-card">
        <div className="text-terracotta text-sm tracking-widest uppercase font-medium">That's Tuft</div>
        <h1 className="mt-1 font-serif text-3xl font-bold">Studio Login</h1>
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Email</label>
            <input data-testid="admin-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-2xl border border-cream-alt px-4 py-3 focus:ring-2 focus:ring-terracotta focus:outline-none"/>
          </div>
          <div>
            <label className="text-sm font-medium">Password</label>
            <input data-testid="admin-password" required type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1 w-full rounded-2xl border border-cream-alt px-4 py-3 focus:ring-2 focus:ring-terracotta focus:outline-none"/>
          </div>
          <button data-testid="admin-login-btn" disabled={busy} type="submit" className="w-full rounded-full bg-terracotta text-white px-8 py-3 font-semibold shadow-button disabled:opacity-60">{busy ? "…" : "Sign in"}</button>
        </div>
      </form>
    </div>
  );
}
